import axios from '../utils/axiosConfig';

// Helper function to set auth headers
// Removed this function as it's now handled by the interceptor

// Get all callsheets for a project
export const getProjectCallsheets = async (projectId, filters = {}) => {
  try {
    let url = `/api/v1/callsheets/project/${projectId}`;
    
    // Add query parameters for filtering
    const queryParams = new URLSearchParams();
    if (filters.status) queryParams.append('status', filters.status);
    if (filters.startDate) queryParams.append('startDate', filters.startDate);
    if (filters.endDate) queryParams.append('endDate', filters.endDate);
    
    if (queryParams.toString()) {
      url += `?${queryParams.toString()}`;
    }
    
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching callsheets:', error);
    throw error;
  }
};

// Get a single callsheet by ID
export const getCallsheet = async (callsheetId) => {
  try {
    const response = await axios.get(`/api/v1/callsheets/${callsheetId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching callsheet:', error);
    throw error;
  }
};

// Get the latest callsheet for a project
export const getLatestCallsheet = async (projectId) => {
  try {
    const response = await axios.get(`/api/v1/callsheets/project/${projectId}/latest`);
    return response.data;
  } catch (error) {
    console.error('Error fetching latest callsheet:', error);
    throw error;
  }
};

// Get callsheet by shooting day
export const getCallsheetByDay = async (projectId, shootingDay) => {
  try {
    const response = await axios.get(`/api/v1/callsheets/project/${projectId}/day/${shootingDay}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching callsheet by day:', error);
    throw error;
  }
};

// Advance to next shooting day (duplicates latest callsheet)
export const advanceShootingDay = async (projectId) => {
  try {
    const response = await axios.post(`/api/v1/callsheets/project/${projectId}/advance-day`);
    return response.data;
  } catch (error) {
    console.error('Error advancing shooting day:', error);
    throw error;
  }
};

// Create a new callsheet
export const createCallsheet = async (callsheetData) => {
  try {
    const response = await axios.post('/api/v1/callsheets', callsheetData);
    return response.data;
  } catch (error) {
    console.error('Error creating callsheet:', error);
    throw error;
  }
};

// Update an existing callsheet
export const updateCallsheet = async (callsheetId, callsheetData) => {
  try {
    const response = await axios.put(`/api/v1/callsheets/${callsheetId}`, callsheetData);
    return response.data;
  } catch (error) {
    console.error('Error updating callsheet:', error);
    throw error;
  }
};

// Delete a callsheet
export const deleteCallsheet = async (callsheetId) => {
  try {
    const response = await axios.delete(`/api/v1/callsheets/${callsheetId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting callsheet:', error);
    throw error;
  }
};

// Publish a callsheet
export const publishCallsheet = async (callsheetId) => {
  try {
    const response = await axios.patch(`/api/v1/callsheets/${callsheetId}/publish`, {});
    return response.data;
  } catch (error) {
    console.error('Error publishing callsheet:', error);
    throw error;
  }
};

// Duplicate a callsheet
export const duplicateCallsheet = async (callsheetId, newDate) => {
  try {
    // First get the original callsheet
    const originalCallsheet = await getCallsheet(callsheetId);
    
    // Create a new callsheet object with updated date and incremented shooting day
    const newCallsheet = {
      ...originalCallsheet,
      date: newDate,
      shootingDay: (originalCallsheet.shootingDay || 1) + 1, // Increment the shooting day
      status: 'draft', // Always start as draft
      _id: undefined // Remove the ID so a new one is created
    };
    
    // Create the new callsheet
    return await createCallsheet(newCallsheet);
  } catch (error) {
    console.error('Error duplicating callsheet:', error);
    throw error;
  }
};
